import { FunctionComponent, MouseEvent, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import sprite from '../../../assets/icons/sprite.svg';
import { CircularLoader } from '../CircularLoader';

import classNames from 'classnames';
import classes from './NotificationToggle.module.scss';

interface NotificationToggleProps {
  isEnabled: boolean;
  isPending: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export const NotificationToggle: FunctionComponent<NotificationToggleProps> = memo(
  ({ isEnabled, isPending, onClick, className }) => {
    const { t } = useTranslation();

    const icon = useMemo(() => {
      if (isPending) {
        return (
          <CircularLoader
            className={classes['notification__loader']}
            sizeRem={1.125}
            borderRem={0.125}
          />
        );
      }

      return (
        <svg className={classes['notification__icon']}>
          <use href={`${sprite}#bell${isEnabled ? '' : '-off'}`} />
        </svg>
      );
    }, [isEnabled, isPending]);

    return (
      <button
        type={'button'}
        className={classNames(classes['notification'], className, {
          [classes['notification--enabled']]: isEnabled,
        })}
        aria-label={t('common.notification')}
        aria-pressed={isEnabled}
        aria-disabled={isPending}
        onClick={(event) => !isPending && onClick(event)}
      >
        {icon}
      </button>
    );
  }
);
